module.exports = __webpack_public_path__ + "img/city12.0a37cffc.jpg";